<template>
  <div>
    <h3>Coordinación de Instalacción y Registro de Equipos</h3>
    <el-form>
      <el-row :gutter="20">
        <el-col :span="5">
          <span> Técnico </span>
        </el-col>
        <el-col :span="4">
          <span> Modelo </span>
        </el-col>
        <el-col :span="4">
          <span> Serial </span>
        </el-col>
        <el-col :span="4">
          <span> SIM </span>
        </el-col>
        <el-col :span="7">
          <span> {{ CommentTitle }} </span>
        </el-col>
      </el-row>
      <el-row
        v-for="(installation, rowIndex) in rowData.DeviceQuantity"
        :key="rowIndex"
        :gutter="20"
      >
        <el-col :span="5">
          <el-form-item>
            <el-select
              v-model="SelectedTechnician"
              placeholder="Técnico"
              filterable
              disabled
            >
              <el-option
                v-for="(item, index) in technicians"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option
            ></el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-select
              v-model="instalationLines[rowIndex].DeviceDescription"
              placeholder="Modelo"
              filterable
              v-loading="modelLoading"
              @change="handleModelChange"
            >
              <el-option
                v-for="item in modelsList"
                :key="item.value"
                :label="item.label"
                :value="{ model: item, rowIndex: rowIndex }"
              >
              </el-option
            ></el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <el-form-item>
            <el-input-number
              v-model="quantityPerInstalation"
              :disabled="true"
            ></el-input-number>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="4">
          <el-form-item>
            <el-input
              v-model="instalationLines[rowIndex].Comment"
              placeholder="Comentario"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="4">
          <el-form-item>
            <el-select
              v-model="instalationLines[rowIndex].Serial"
              placeholder="Serial"
              filterable
              v-loading="serialLoading"
              @change="handleSerialChange"
            >
              <el-option
                v-for="(item, itemIndex) in serialList"
                :key="itemIndex"
                :label="item.Serial"
                :disabled="item.disabled"
                :value="{
                  serial: item,
                  itemIndex: itemIndex,
                  rowIndex: rowIndex
                }"
              >
              </el-option
            ></el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-select
              v-model="instalationLines[rowIndex].SIMNumber"
              placeholder="SIM"
              filterable
              v-loading="simLoading"
              @change="handleSimChange"
            >
              <el-option
                v-for="(item, itemIndex) in simList"
                :key="item.PhoneNumber"
                :label="item.PhoneNumber"
                :disabled="item.disabled"
                :value="{ SIM: item, itemIndex: itemIndex, rowIndex: rowIndex }"
              >
              </el-option
            ></el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item>
            <el-input
              v-model="instalationLines[rowIndex].Comment"
              :placeholder="CommentTitle"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";
import { technicians } from "@/views/modules/technical_support/requests/requests";

export default {
  name: "AssignTechnicianInstalationForm",
  props: {
    rowData: {
      type: Object
    },
    SelectedTechnician: {
      type: Number
    },
    Tab: {
      type: String
    }
  },
  data() {
    return {
      requestData: {},
      diveDict: null,
      modelsList: [],
      modelLoading: false,
      technicians: technicians,
      modelList: {
        devices: [],
        deviceTypes: []
      },

      //Coordinación de Instalación
      selectedModel: "",
      quantityPerInstalation: 1,
      instalationComment: "",

      //Registro de Dispositivos
      selectedSerial: [],
      serialList: [],
      serialLoading: false,
      simList: [],
      simLoading: false,
      selectedSIMs: [],
      deviceTitle: "",

      instalationLines: [
        {
          Device: "",
          Comment: "",
          DeviceId: "",
          DeviceTypeId: "",
          DeviceDescription: "",
          Quantity: 1,
          TechnicianId: this.SelectedTechnician,
          DeviceOperationRequestId: "",
          HaveSIMCard: false,
          IMEI: "",
          SIMNumber: "",
          Serial: "",
          SerialDescription: "",
          SimIMEI: ""
        }
      ],
      InstalationFullRequest: {},
      RequestedDevice: {} // Detalle de la solicitud
    };
  },

  mounted() {
    if (this.rowData.Id) {
      this.getCoordinationData();
    }
  },

  methods: {
    formatArrayToElSelect,
    handleModelChange(rowData) {
      this.instalationLines[rowData.rowIndex].Device = rowData.model;
      this.instalationLines[rowData.rowIndex].DeviceId = rowData.model.Id;
      this.instalationLines[rowData.rowIndex].DeviceModelId = rowData.model.Id;
      this.instalationLines[rowData.rowIndex].DeviceTypeId =
        rowData.model.DeviceTypeId;
      this.instalationLines[rowData.rowIndex].DeviceDescription =
        rowData.model.Description;

      if (this.Tab == "reallocate") {
        if (
          rowData.model.Id ==
          this.RequestedDevice[rowData.rowIndex].DeviceModelId
        ) {
          this.instalationLines[rowData.rowIndex].Serial =
            this.RequestedDevice[rowData.rowIndex].Serial;
          this.instalationLines[rowData.rowIndex].SIMNumber =
            this.RequestedDevice[rowData.rowIndex].SIMNumber;
        } else {
          this.instalationLines[rowData.rowIndex].Serial = "";
          this.instalationLines[rowData.rowIndex].SIMNumber = "";
        }
      }
    },

    handleSerialChange(rowData) {
      const serial = rowData.serial.Serial;
      const serialIndex = rowData.itemIndex;
      const rowIndex = rowData.rowIndex;
      let foundSerial = this.selectedSerial.find((f) => f.row == rowIndex);
      if (foundSerial) {
        this.serialList[foundSerial.serialIndex].disabled = false;
        const foundSerialIndex = this.selectedSerial.findIndex(
          (f) => f.row == rowIndex
        );
        this.selectedSerial.splice(foundSerialIndex, 1);
      }
      let index = this.serialList.findIndex((f) => f.Serial == serial);
      this.serialList[index].disabled = true;

      this.selectedSerial.push({
        serial: serial,
        row: rowIndex,
        serialIndex: serialIndex
      });
      this.instalationLines[rowIndex].Serial = serial;
    },

    handleSimChange(rowData) {
      const sim = rowData.SIM;
      const simIndex = rowData.itemIndex;
      const rowIndex = rowData.rowIndex;

      let foundSIM = this.selectedSIMs.find((f) => f.row == rowIndex);
      if (foundSIM) {
        this.simList[foundSIM.simIndex].disabled = false;
        const foundSIMIndex = this.selectedSIMs.findIndex(
          (f) => f.row == rowIndex
        );
        this.selectedSIMs.splice(foundSIMIndex, 1);
      }

      let index = this.simList.findIndex(
        (f) => f.PhoneNumber == sim.PhoneNumber
      );
      this.simList[index].disabled = true;

      this.selectedSIMs.push({
        phone: sim.PhoneNumber,
        row: rowIndex,
        simIndex: simIndex
      });
      this.instalationLines[rowIndex].IMEI = sim.IMEI;
      this.instalationLines[rowIndex].SIMNumber = sim.PhoneNumber;
    },

    //LLAMADAS A API
    getCoordinationData() {
      this.modelLoading = true;
      this.$http
        .get(`/api/serviceRequests/${this.rowData.Id}/details`)
        .then(({ data }) => {
          this.requestData = data;
          this.addInstalationLines(); //llenar la lista de lineas de instalacion
          this.modelLoading = false;
          if (this.requestData.DeviceQuantity > 0) {
            this.$http.get("/api/devices/typeDictionary").then(({ data }) => {
              this.diveDict = data;
              this.initDevs(); // LISTA DROPDOWN MODELO
              this.getAvailableDevices(); // LISTA DROPDOWN SERIALES
              this.getAvailableSims(); // LISTA DROPDOWN SIMS
            });
          }
          this.RequestedDevice = data.RequestedDevices;
        });
    },

    addInstalationLines() {
      this.instalationLines = [];
      const DeviceQuantity = this.requestData.DeviceQuantity; //Total de Dispositivos
      const RequestedDevices = this.requestData.RequestedDevices; //Datos de los Dispositivos

      // Si la solicitud tiene más de un dispositivo y se va areasignar, entonces llena la linea con la data de la petición al API, de lo contrario crea una linea vacía.
      if (DeviceQuantity > 0 && this.Tab == "reallocate") {
        for (let i = 0; i < DeviceQuantity; i++) {
          let line = {
            Comment: this.requestData.DeviceOperationRequests[i].Comment,
            Device: RequestedDevices[i].DeviceModel,
            DeviceId: RequestedDevices[i].Id,
            DeviceTypeId: RequestedDevices[i].DeviceTypeId,
            DeviceModelId: RequestedDevices[i].DeviceModelId,
            DeviceDescription: RequestedDevices[i].DeviceModel.Description,
            DeviceOperationRequestId:
              RequestedDevices[i].DeviceOperationRequestId,
            Quantity: 1,
            ServiceRequestId: this.rowData.Id,
            TechnicianId: this.rowData.AssignedTechnician.Id,
            UpdatedBy: this.currentUser.UserID,
            Serial: RequestedDevices[i].Serial,
            SIMNumber: RequestedDevices[i].SIMNumber,
            IMEI: RequestedDevices[i].IMEI
          };
          this.instalationLines.push(line);
        }
      } else {
        for (let i = 0; i < DeviceQuantity; i++) {
          this.instalationLines.push({
            Comment: "",
            Device: "",
            DeviceId: "",
            DeviceTypeId: "",
            DeviceModelId: "",
            DeviceDescription: "",
            DeviceOperationRequestId: "",
            Quantity: 1,
            ServiceRequestId: this.rowData.Id,
            TechnicianId: this.SelectedTechnician,
            UpdatedBy: this.currentUser.UserID,
            Serial: "",
            SIMNumber: "",
            IMEI: ""
          });
        }
      }
    },

    //Format Product Model SELECTOR
    initDevs() {
      let listDevTypes = [];
      for (
        let i1 = 0;
        i1 < this.requestData.RequestDeviceTypeQuantities.length;
        i1++
      ) {
        const rdtq = this.requestData.RequestDeviceTypeQuantities[i1];
        let devType = {
          title: `${rdtq.DeviceType.Description} (${rdtq.Quantity})`,
          devices: [],
          quantity: rdtq.Quantity,
          type: rdtq.DeviceTypeId
        };

        let flag = false;
        for (let i2 = 0; i2 < rdtq.Quantity; i2++) {
          if (!flag) {
            devType.devices.push({
              model_list: this.formatArrayToElSelect(
                this.diveDict[rdtq.DeviceTypeId],
                {
                  label: "Description"
                }
              ),
              comment: "",
              quantity: rdtq.Quantity,
              technical_id: this.requestData.AssignedTechnicianId,
              DeviceTypeId: rdtq.DeviceTypeId
            });

            this.modelList[`${i1}_${i2}_model`] = null;
            this.modelList[`${i1}_${i2}_comment`] = "";
            this.modelList[`${i1}_${i2}_quantity`] = rdtq.Quantity;
            this.modelList[`${i1}_${i2}_technical_id`] =
              this.requestData.AssignedTechnicianId;

            flag = true;
          }
        }
        listDevTypes.push(devType);
      }

      const devicesList = listDevTypes;
      this.modelsList = devicesList[0].devices[0].model_list;
    },

    getAvailableDevices() {
      if (this.Tab != "reallocate") {
        this.serialLoading = true;
      }
      this.$http
        .get("/api/inventory/availableDevices", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            CompanyCode: this.currentCompany,
            LocationCode: this.requestData.Product.Codes,
            AssetType: 1
          }
        })
        .then(({ data }) => {
          const availableDevices = this.formatArrayToElSelect(data, {
            label: "IMEI",
            value: "IMEI"
          });
          this.serialList = availableDevices.slice(0, 20);
          this.serialLoading = false;
        })
        .catch((error) => {
          this.serialLoading = false;
          console.error(error);
        });
    },

    getAvailableSims() {
      if (this.Tab != "reallocate") {
        this.simLoading = true;
      }
      this.$http
        .get("/api/inventory/availableSims", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            //SE LE MANDA NULO PAR QUE TRAIGA TODO
            PhoneNumber: null,
            DeviceSerial: null,
            CompanyID: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.simList = data.Items.splice(0, 20);
          this.simLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getFormData() {
      this.InstalationFullRequest = {
        LocationCode: this.requestData.Product.Codes,
        RequestId: this.rowData.Id,
        UserId: this.currentUser.UserID,
        Request: this.rowData,
        InstallationRequests: this.instalationLines
      };
      return this.InstalationFullRequest;
    },

    clearData() {
      //Se usa en el componente padre. (RequestList.vue)
      this.selectedModel = "";
      this.selectedSerial = [];
      this.instalationComment = "";
      this.selectedSIMs = [];
      this.deviceTitle = "";
      this.requestData = {};
      this.instalationLines = [
        {
          Device: "",
          Comment: "",
          DeviceId: "",
          DeviceTypeId: "",
          DeviceDescription: "",
          Quantity: 1,
          TechnicianId: this.SelectedTechnician,
          DeviceOperationRequestId: "",
          HaveSIMCard: false,
          IMEI: "",
          SIMNumber: "",
          Serial: "",
          SerialDescription: "",
          SimIMEI: ""
        }
      ];
    }
  },
  watch: {
    SelectedTechnician(currentTechnician) {
      this.instalationLines.forEach((line) => {
        line.TechnicianId = currentTechnician;
      });
    }
  },
  computed: {
    CommentTitle() {
      if (this.Tab == "reallocate") {
        return "Editar Descripción de Dispositivo";
      } else {
        return "Descripción de Dispositivo";
      }
    },
    GetInstalationLines() {
      let installation = [];
      for (let i = 0; i < this.rowData.DeviceQuantity; i++) {
        installation.push({
          Device: "",
          Comment: "",
          DeviceId: "",
          DeviceTypeId: "",
          DeviceDescription: "",
          Quantity: 1,
          TechnicianId: this.SelectedTechnician,
          DeviceOperationRequestId: "",
          HaveSIMCard: false,
          IMEI: "",
          SIMNumber: "",
          Serial: "",
          SerialDescription: "",
          SimIMEI: ""
        });
      }
      return installation;
    }
  }
};
</script>

<style></style>
